import QuizForm from "./QuizForm";

// Novo questionário: o formulário compartilhado com o editar
export default function NewQuiz() {
  return <QuizForm />;
}
